import { useMemo } from "react";
import { GroupE, GroupT, PathsE } from "../../../../routes";
import { DTO } from "shared/api/types/services";

interface Props {
  groups: GroupT[];
  services: DTO[];
}

export const useAccordionData = ({ groups, services }: Props) => {
  return  useMemo(() => {
    const res: { group: GroupT; serviceName?: string, mock?: boolean }[] = [];
    groups.forEach((group: GroupT) => {

      if (group.group === GroupE.TG) res.push({ group });

      else if (group.group === GroupE.AI) {
        if (services.length > 0) {
          services.forEach((service) => {
            res.push({
              group: {
                ...group,
                routes: group.routes.map((route) => {
                  return { ...route, path: route.path.replace(/:serviceId\b/, service.id) as PathsE  }
                }),
              },
              serviceName: service.name,
            });
          });
        } else {
          res.push({
            group: { ...group, routes: group.routes.map((route) => ({ ...route, isDisabled: true })) },
            mock: true,
          });
        }
      }
    });

    return res;
  }, [groups, services]);

};
